import { useEffect, useContext } from 'react'
import * as SentryClient from '@sentry/react'
import { AppContext } from '../../index'

function Sentry() {
  const { state } = useContext(AppContext)
  const userEmail = state.auth.user?.email
  const user = state.auth.user

  useEffect(() => {
    const sentryDsn = process.env.REACT_APP_SENTRY_DSN
    const sentryEnv = process.env.REACT_APP_SENTRY_ENVIRONMENT

    if (sentryDsn && sentryEnv && userEmail) {
      SentryClient.init({
        dsn: sentryDsn,
        environment: sentryEnv,
        defaultIntegrations: false
      })

      if (user) {
        const userFullName = `${user.firstName} ${user.lastName}`
        SentryClient.configureScope(scope => {
          scope.setUser({
            id: userEmail,
            username: userFullName,
            email: userEmail
          })
        })
      }
    }
  },
    // eslint-disable-next-line
    [userEmail])

  return null
}

export default Sentry
